module.exports = __webpack_public_path__ + "img/ring_y_c_1_0.3cbbd936.png";